<template>
  <div class="add-on-container">
    <div class="add-on-list">
      <div class="page-header">
        <div class="page-kicker">健康加值｜自費健檢</div>
        <div class="page-divider"></div>
        <h1 class="page-title">加值健檢</h1>
        <div class="page-subtitle">選擇適合您的額外檢查項目</div>
      </div>
      <div class="checkboxes-container">
        <h4 class="section-title">請確認加值項目</h4>
        <Checkboxes
          v-model="proxy"
          :options="options"
          :value-key="'value'"
          :label-key="'label'"
          :right-display-key="'right_display_info'"
          :detailed-info-key="'detailed_info'"
          :expandable-key="'expandable'"
        >
          <template #details="{ details }">
            <ul v-if="Array.isArray(details)" class="info-list">
              <li v-for="(t, i) in details" :key="i">
                <template v-if="isDetailObject(t)">
                  <span v-if="t.title">{{ t.title }}</span><br v-if="t.title && t.text" />
                  <span v-if="t.text">{{ t.text }}</span>
                </template>
                <template v-else>{{ t }}</template>
              </li>
            </ul>
            <div v-else>{{ details }}</div>
          </template>
        </Checkboxes>
      </div>
    </div>

    <div class="cost-summary">
      <h4>費用摘要</h4>
      <div class="summary-item">
        <span>基本費用</span>
        <span>{{ baseFee }} 元</span>
      </div>
      <div class="summary-item">
        <span>加值費用</span>
        <span>{{ addOnTotal }} 元</span>
      </div>
      <hr />
      <div class="summary-total">
        <span>總金額</span>
        <span>{{ totalCost }} 元</span>
      </div>
    </div>
  </div>
</template>

<script>
import Checkboxes from '@/components/web/proj/tongxin/common/Checkboxes.vue'

export default {
  name: 'AddOn',
  components: { Checkboxes },
  model: { prop: 'value', event: 'input' },
  props: {
    value: { type: Array, default: () => [] },
    options: { type: Array, default: () => [] },
    baseFee: { type: Number, default: 0 }
  },
  computed: {
    proxy: {
      get() {
        return Array.isArray(this.value) ? this.value : []
      },
      set(v) {
        this.$emit('input', Array.isArray(v) ? v : [])
      }
    },
    selectedAddOns() {
      const set = new Set((this.value || []).map(v => String(v)))
      return (this.options || []).filter(o => set.has(String(o.value)))
    },
    addOnTotal() {
      return this.selectedAddOns.reduce((sum, item) => sum + (item.price || 0), 0)
    },
    totalCost() {
      return (this.baseFee || 0) + this.addOnTotal
    }
  },
  methods: {
    isDetailObject(detail) {
      return !!detail && typeof detail === 'object' && !Array.isArray(detail)
    }
  }
}
</script>

<style scoped>
/* Container */
.add-on-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 24px;
  padding: 16px 0;
}

/* Left section */
.add-on-list {
  flex: 1 1 60%;
}

/* Page header */
.page-header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  margin: 8px 0;
  border: none;
  box-shadow: none;
}

.page-kicker {
  color: #207868;
  font-weight: 700;
  font-size: 16px;
  letter-spacing: 0.5px;
}

.page-divider {
  height: 1px;
  background-color: #d1d9d8;
  width: 100%;
  margin-top: 8px;
}

.page-title {
  color: #207868;
  font-weight: 800;
  font-size: 28px;
  line-height: 1.2;
  font-weight: bold;
  margin: 24px 0;
}

.page-subtitle {
  color: #5f7e78;
  font-size: 18px;
  margin-bottom: 48px;
}

@media (max-width: 768px) {
  .page-title { font-size: 32px; }
  .page-subtitle { font-size: 16px; }
}

/* Checkbox section */
.section-title {
  font-size: 18px;
  font-weight: 300;
  color: #333;
  margin-bottom: 16px;
}

.checkboxes-container {
  background-color: #f7f9f8;
  border-radius: 16px;
  padding: 24px;
  border: 1px solid #e6f0ee;
  border-left: 4px solid #2a9d8f;
}

/* Right section - cost summary */
.cost-summary {
  width: 260px;
  background: linear-gradient(180deg, #157f74 0%, #1aa088 100%);
  border-radius: 16px;
  padding: 24px;
  font-weight: 500;
  font-size: 16px;
  position: sticky;
  top: 100px;
  align-self: flex-start;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
}

/* Apply white color to all relevant sub-elements */
.cost-summary,
.selected-title,
.selected-list .name,
.selected-list .price {
  color: white;
}

.cost-summary h4 {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 16px;
}

.summary-item,
.summary-total {
  display: flex;
  justify-content: space-between;
  margin: 10px 0;
}

.summary-total {
  font-size: 20px;
  font-weight: 700;
  margin-top: 16px;
}

.summary-total span:last-child {
  font-size: 24px;
  font-weight: 800;
}

hr {
  border: none;
  border-top: 1px solid rgba(255, 255, 255, 0.3);
  margin: 12px 0;
}

/* Selected add-on list */
.selected-addons {
  margin-top: 24px;
  padding-top: 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.3);
}

.selected-title {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 8px;
}

.selected-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.selected-list li {
  display: flex;
  justify-content: space-between;
  padding: 6px 0;
}

.info-list {
  margin: 0;
  padding-left: 18px;
  list-style: none;
}

.info-list li {
  padding-bottom: 12px;
}

.info-list li:last-child {
  padding-bottom: 0;
}

/* Responsive layout */
@media (max-width: 768px) {
  .add-on-container {
    flex-direction: column;
  }

  .add-on-list {
    flex: 1 1 100%;
  }

  .cost-summary {
    position: relative;
    width: 100%;
    margin-top: 24px;
    top: unset;
    align-self: unset;
  }
}
</style>
